var map = {
	"./img/Anymag_logo.svg": 284,
	"./img/Facebook_20x20.svg": 285,
	"./img/Instagram_20x20.svg": 286,
	"./img/Linkedin_20x20.svg": 287,
	"./img/Spotin_SymbolS_Ring_Off_White_Small_RGB.png": 288,
	"./img/Spotin_SymbolS_Square_Off_White_Big_RGB.png": 289,
	"./img/Spotin_TM_Logo_Off-White_Big_RGB.png": 290,
	"./img/Spotin_TM_Logo_Off-White_Small_RGB.png": 291,
	"./img/Spotin_TM_Logo_Sand_Big_RGB.png": 292,
	"./img/Spotin_TM_Logo_Sand_Small_RGB.png": 293,
	"./img/articlelinkimage_1.jpg": 294,
	"./img/articlelinkimage_2.jpg": 295,
	"./img/articlelinkimage_3.jpg": 296,
	"./img/articlelinkimage_4.jpg": 297,
	"./img/book_1.png": 298,
	"./img/book_2.png": 299,
	"./img/bookarticle.jpg": 300,
	"./img/header_1.jpg": 301,
	"./img/header_1_new.jpg": 302,
	"./img/header_2.jpg": 303,
	"./img/trainingarticle_1.jpg": 304,
	"./img/trainingarticle_2.jpg": 305,
	"./img/trainingarticle_3.jpg": 306,
	"./img/trendarticle_1.jpg": 307,
	"./img/trendarticle_2.jpg": 308,
	"./sass/style.sass": 28
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 607;


//////////////////
// WEBPACK FOOTER
// ./demo ^.*
// module id = 607
// module chunks = 0